<template>
	<div id="app">
		<!-- 为了配合置顶功能创建的dom -->
		<div id="topdom"></div>
		<!-- <keep-alive include='search'>
			<router-view></router-view>
		</keep-alive> -->
		<router-view></router-view>
	</div>
</template>

<script>
	import {
		getConfig
	} from '@/api/user.js'
	export default {
		name: 'app',
		mounted() {
			let flag = navigator.userAgent.match(
				/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
			)
			if (flag) {
				window.location.href = 'https://h5.houniao.hk/'
			} else {
				return false
			}
		},
		computed: {
			config() {
				return this.$store.state.user.config
			}
		},
		watch: {
			$route() {
				getConfig().then(response => {
					this.$store.state.user.config = response.data
					document.title = `${document.title}-${this.config.shop_introduce}`
				})
			}
		}
	}
</script>

<style>
	#app {
		font-family: PingFangSC-Regular, PingFang SC;
		-webkit-font-smoothing: antialiased;
		-moz-osx-font-smoothing: grayscale;
		text-align: center;
		font-size: 12px;
	}

	body,
	h1,
	h2,
	h3,
	p {
		margin: 0;
		padding: 0;
	}

	.flex-between {
		display: flex;
		justify-content: space-between;
		align-items: center;
	}

	.flex-start {
		display: flex;
		justify-content: flex-start;
		align-items: center;
	}

	.flex-center {
		display: flex;
		justify-content: center;
		align-items: center;
	}

	.flex-around {
		display: flex;
		justify-content: space-around;
		align-items: center;
	}

	/* 改变el-loading的样式 */
	.el-loading-spinner {
		/*这个是自己想设置的 gif 加载动图*/
		background-image: url(https://images.houniao.hk/wstmart/home/view/default/public/common/images/loading.gif);
		background-repeat: no-repeat;
		background-size: 200px 80px;
		height: 80px;
		/* width:100%; */
		background-position: center;
		/*覆盖 element-ui  默认的 50%    因为此处设置了height:100%,所以不设置的话，会只显示一半，因为被top顶下去了*/
		/* top:50%; */
	}

	.el-loading-spinner .circular {
		/*隐藏 之前  element-ui  默认的 loading 动画*/
		display: none;
	}

	.el-dialog__body {
		padding: 20px;
	}

	.el-loading-spinner .el-loading-text {
		/*为了使得文字在loading图下面*/
		/* margin:85px 0px; */
	}
</style>
